<template>
  <c-tick-flash :value="params.value">
    {{ params.valueFormatted }}<span class="sr-only">{{ $t('white-label.globalLabels.buttonAria') }}</span>
  </c-tick-flash>
</template>

<script>
import CTickFlash from '@custom/CTickFlash';

export default {
  name: 'tick-flash-renderer',
  components: {
    CTickFlash
  },
  methods: {
    refresh(params) {
      if (params.value !== this.params.value) {
        this.params = params;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-tick-flash {
  &:hover {
    color: $white;
  }
}
</style>
